import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { CardProps, InputTypes, setLengthMin, StateProps } from "../../store";
import InputCheckbox from "../InputCheckbox";
import InputRadio from "../InputRadio";
import InputSelect from "../InputSelect";
import InputTextField from "../InputTextField";
import PreviewCardTitle from "../PreviewCardTitle";
import * as S from "./styles";
import SubText from "../SubText";
import InputTextAreaField from "../InputTextAreaField";
import InputFile from "../InputFile";
import InputFileList from "../InputFileList";
import { LengthMinSection, LengthMinSpan } from "./styles";
import { useForm } from "react-hook-form";

const PreviewCard = ({ id }: Pick<CardProps, "id">) => {
  const inputType = useSelector((state: StateProps) => {
    const currentCard = state.cards.find((card) => card.id === id) as CardProps;
    return currentCard.inputType;
  }) as string;

  const methods = useForm();
  const requiredCardIds = useSelector((state: StateProps) => state.required as string[]);
  const lengthMinCardIds = useSelector((state: StateProps) => state.lengthMin as string[]);
  const [currentLength, setCurrentLength] = useState(0);

  const isTitle = inputType === InputTypes.TITLE;
  const needToCompleteRequired = requiredCardIds.includes(id);
  const needToCompleteLengthMin = lengthMinCardIds.includes(id);

  const hasLengthMinRequire = useSelector((state: StateProps) => {
    const currentCard = state.cards.find((card) => card.id === id) as CardProps;
    return currentCard.lengthMin !== undefined && currentCard.lengthMin !== 0;
  });

  const lengthMin = useSelector((state: StateProps) => {
    const currentCard = state.cards.find((card) => card.id === id) as CardProps;
    return currentCard.lengthMin ?? 100;
  });

  useEffect(() => {
    setCurrentLength(getCurrentAnswerLength());
  }, []);

  const getCurrentAnswerLength = () => {
    console.log('getCurrentAnswerLength');
    const currentAnswer = methods.getValues()[id]
    if (currentAnswer === undefined) return 0;
    return currentAnswer.length;
  }

  return (
    <S.Container id={id}>
      <S.Card needToRed={needToCompleteRequired || needToCompleteLengthMin} isTitle={isTitle}>
        {isTitle ? <S.HeightSpace /> : null}
        <PreviewCardTitle id={id} />
        {inputType !== InputTypes.TITLE ? <SubText id={id} /> : null}
        {inputType === InputTypes.TEXT ? <InputTextField id={id} setCurrentLength={setCurrentLength} /> : null}
        {inputType === InputTypes.NAME ? <InputTextField id={id} setCurrentLength={setCurrentLength} /> : null}
        {inputType === InputTypes.CONTACT ? <InputTextField id={id} setCurrentLength={setCurrentLength} /> : null}
        {inputType === InputTypes.TEXTAREA ? <InputTextAreaField id={id} setCurrentLength={setCurrentLength} /> : null}
        {inputType === InputTypes.RADIO ? <InputRadio id={id} /> : null}
        {inputType === InputTypes.CHECKBOX ? <InputCheckbox id={id} /> : null}
        {inputType === InputTypes.SELECT ? <InputSelect id={id} /> : null}
        {inputType === InputTypes.FILE ? <InputFile id={id} /> : null}
        {inputType === InputTypes.FILE ? <InputFileList id={id} /> : null}
        {needToCompleteRequired ? (
          <S.RequiredSection>
            <S.RequiredSpan>필수 질문입니다.</S.RequiredSpan>
          </S.RequiredSection>
        ) : null}
        {needToCompleteLengthMin ? (
          <S.RequiredSection>
            <S.RequiredSpan>최소 글자 수(파일 수)를 확인해주세요.</S.RequiredSpan>
          </S.RequiredSection>
        ) : null}
        {hasLengthMinRequire && (inputType === InputTypes.TEXT || inputType === InputTypes.TEXTAREA) ? (
          <S.LengthMinSection>
            <S.CurrentLengthSpan isUnder={currentLength < lengthMin}>{currentLength}</S.CurrentLengthSpan>
            <S.LengthMinSpan>&nbsp;/ 최소 {lengthMin}자</S.LengthMinSpan>
          </S.LengthMinSection>
        ) : null}
      </S.Card>
    </S.Container>
  );
};

export default PreviewCard;
